import { readContract, writeContractAndWait } from "../viem";

import OgNFTAbi from "../../abis/ERC1155.json";

import config from "../../config/config";

const address = config.ogNFTAddress;
const abi = OgNFTAbi;

export const ogNFTBalance = async (account: string) => {
  const balance: number = await readContract({
    address,
    abi,
    functionName: "balanceOf",
    args: [account, 0],
  });

  return balance;
};

export const isOGNFTApprovedForAll = async (
  account: string,
  address: string
) => {
  const isApproved: boolean = await readContract({
    address: config.ogNFTAddress,
    abi,
    functionName: "isApprovedForAll",
    args: [account, address],
  });

  return isApproved;
};

export const setOGNFTApprovalForAll = async (
  operator: string,
  approved: boolean,
  account: string
) => {
  await writeContractAndWait({
    address,
    abi,
    functionName: "setApprovalForAll",
    args: [operator, approved],
    account,
  });
};
